// 대리구매 서비스 수수료: 상품가의 10%, 최소 $6.
// 최소 금액은 저가 주문의 인건비와, 배송비에까지 붙는 결제수수료를 방어하기 위한 것.
// 고객에게 보이는 문구도 이 값에서 뽑아 쓰므로 여기만 고치면 전부 따라온다.

export const SERVICE_FEE_RATE = 0.1;
export const SERVICE_FEE_MIN_USD = 6;

/** 상품가 기준 서비스 수수료 (USD) */
export const serviceFeeUsd = (itemPriceUsd: number) =>
  Math.max(itemPriceUsd * SERVICE_FEE_RATE, SERVICE_FEE_MIN_USD);

/** 문구용 요약 — 예: "10% (min $6)" */
export const FEE_SUMMARY = `${SERVICE_FEE_RATE * 100}% (min $${SERVICE_FEE_MIN_USD})`;
